import React, { useRef, useEffect } from 'react';

import style from './style.module.scss';

function bgPosition(idx) {
  return {
    style: {
      backgroundPosition: `left 0 top -${32 * idx}px`,
    },
  };
}

export default function Menu({
  criador,
  configurar,
  publicar,
  clonar,
  // analise,
  excluir,
  defaultAction,
  botType,
  ...props
}) {
  const menuRef = useRef();

  useEffect(() => {
    if (!menuRef.current) return;
    menuRef.current.focus();
    menuRef.current.addEventListener('blur', defaultAction);

    return () => {
      menuRef.current.removeEventListener('blur', defaultAction);
    };
  }, [menuRef, defaultAction]);

  return (
    <div ref={menuRef} tabIndex="-1" {...props} className={style.root}>
      <div
        onClick={criador || defaultAction}
        className={criador ? '' : style.disabled}
        {...bgPosition(0)}
      >
        Criador
      </div>

      {botType === 'voice' && (
        <div onClick={clonar} {...bgPosition(4)}>
          Clonar
        </div>
      )}

      {botType !== 'voice' && (
        <>
          <div
            onClick={configurar || defaultAction}
            className={configurar ? '' : style.disabled}
            {...bgPosition(1)}
          >
            Configurar
          </div>

          <div
            onClick={publicar || defaultAction}
            className={publicar ? '' : style.disabled}
            {...bgPosition(2)}
          >
            Publicar
          </div>
        </>
      )}
      {/* <div
			onClick={analise || defaultAction}
			className={analise ? '' : style.disabled}
			{...bgPosition(3)}
		>
			Análise
		</div> */}
      <div
        onClick={excluir || defaultAction}
        className={excluir ? '' : style.disabled}
        {...bgPosition(5)}
      >
        Excluir
      </div>
    </div>
  );
}
